import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { connect } from '../../../reducers/index';
import { url } from '../../../constants/routes';
import './styles.css';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
// import IdentifyGraphic02 from '../img/male-with-bubbles-graphic.svg';
// import IcebergGraphic from './img/iceberg-graphic.svg';
// import GaugeGraphic from './img/emotion-gauge-graphic.svg';

const IdentifyPage = props => {
  return (
    <EducationModuleLayout
      progressStage={2}
      childTitle="Identify"
      progressType="identify"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <h2 className="txt-purple no-bold no-margin">Behaviours, Thoughts and Feelings: What to look for </h2>
            </Col>
          </Row>
          <Row>
            <Col xs={10} xsOffset={1}>
              <p>
                The indicators listed are some of the most common things that might reveal that someone is experiencing a
                mental health challenge. It’s important to note that these lists are not comprehensive but can serve as a
                guiding tool. You may notice none or many of these indicators. <span style={{ fontWeight: "bold" }}>Trust your intuition</span> —
                if you feel concerned, it's still an opportunity to check in.
              </p>
              <p>
                Examples of behaviours, thoughts, and feelings that seem <span style={{ fontWeight: "bold" }}>out of character</span> can include:
              </p>
            </Col>
          </Row>
          <Row>
            <Col xs={10} xsOffset={1}>
              <ul className="list-group">
                <li className="list-group-item">
                  isolating or disengaging from others
                </li>
                <li className="list-group-item">
                  withdrawing from activities they once enjoyed
                </li>
                <li className="list-group-item">
                  changes in alcohol, cannabis, and/or other substance use
                </li>
                <li className="list-group-item">
                  worrisome changes in hygiene or personal appearance
                </li>
                <li className="list-group-item">
                  avoiding classes when presentations or participation is
                  expected
                </li>
                <li className="list-group-item">
                  increasing risk-taking behaviour
                </li>
                <li className="list-group-item">
                  expressing or displaying feelings of intense worry or anxiety
                </li>
                <li className="list-group-item">
                  disinterest in the things they once valued
                </li>
                <li className="list-group-item">
                  unfavourable thoughts about people they care about
                </li>
              </ul>
            </Col>
          </Row>
        </div>
      </section>
      <section>
        <div className="container text-center">
          <Row>
            <Col xs={12}>
              <Button
                className="btn btn-purple previous"
                onClick={() => props.history.goBack()}
              >
                Previous
              </Button>
              <LinkContainer
                to={url.IDENTIFY_C}
                className="btn btn-purple next"
              >
                <Button>Next</Button>
              </LinkContainer>
            </Col>
          </Row>
        </div>
      </section>
    </EducationModuleLayout>
  );
};

IdentifyPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const IdentifyB = IdentifyPage;
export default connect.role(IdentifyB);



// WEBPACK FOOTER //
// ./src/containers/Identify/IdentifyB/index.jsx